import type { ComponentType } from 'react';
import type { IconProps, IconWeight } from '@phosphor-icons/react';

const SIZE = { sm: 16, md: 20, lg: 24 } as const;

export type IconSize = keyof typeof SIZE;

export type DsIconProps = {
  /** A Phosphor icon component, e.g. `Binoculars` (watching) or `BellSimple` (alerts only). */
  icon: ComponentType<IconProps>;
  size?: IconSize;
  weight?: IconWeight;
  /** Accessible name. Without one the icon is decorative and hidden from assistive tech. */
  label?: string;
  className?: string;
};

/**
 * The one way design-system components draw an icon: Phosphor, sized from the scale, colour from
 * the surrounding text (currentColor). Decorative unless given a label.
 */
export function Icon({ icon: Glyph, size = 'md', weight = 'bold', label, className }: DsIconProps) {
  return (
    <Glyph
      size={SIZE[size]}
      weight={weight}
      className={className}
      aria-hidden={label ? undefined : true}
      aria-label={label}
      role={label ? 'img' : undefined}
      focusable="false"
    />
  );
}
